import { withTranslation } from '@application/i18n/with_translation';
import { Text } from '@cellula/react';

export function MyAccountTitle(_: unknown): JSX.Element {
	return <Text.h1 variant='headingMedium'>{withTranslation('PW.Feature.MyAccount.Title')}</Text.h1>;
}
